import React from "react";
import { Link } from "react-router-dom";

const TopNavabr = () => {
  return (
    <section className="bg-black text-white">
      <div className="container-fluid">
        <div className="mx-7 px-4">
          <div
            className="d-flex justify-content-end fs-16"
            style={{ padding: "1.6rem 0" }}
          >
            {/* <div className=" flex-grow-1">
              Language <BiChevronDown size={24} />
            </div> */}
            <div className="me-5">
              <Link
                to="/contact-us"
                className="text-decoration-none text-white"
              >
                Contact Us
              </Link>
            </div>
            <div className="d-flex align-items-center">
              {/* <p>
                <CgProfile size={16} />
              </p> */}
              <p className="ms-2 cursor-pointer">
                {/* <a
                  href={`${DASHBOARD_URL}`}
                  target="_blank"
                  rel="noreferrer"
                  className="text-decoration-none footer-text"
                >
                  Login
                </a> */}
                <Link
                  to="/app-store"
                  className="text-decoration-none footer-text"
                >
                  Login
                </Link>
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default TopNavabr;
